export var defaultOptions = {
    el: '',
    appId: '',
    defaultStatus: 'accept'
};
export var CLASS_NAMES = {
    container: 'cookie-opt-out-container',
    activeContainer: 'cookie-opt-out-container-active',
    activeSwitch: 'cookie-opt-out-switch-active',
};
export var COOKIE_OPT_OUT_KEY = 'Website_Cookie_Opt_Out_Status';
export var DEFAULT_OPT_OUT_PRIVACY_BUTTON = 'Your Privacy Choices';
export var DEFAULT_OPT_OUT_TITLE = 'Your Privacy Choices';
export var DEFAULT_SAVE_BUTTON_TEXT = 'Save';
export var DEFAULT_OPT_OUT_DESC = {
    title: DEFAULT_OPT_OUT_TITLE,
    desc: [
        {
            text: 'The California Consumer Privacy Act (CCPA) gives consumers the right to opt-out of “sales” and “shares” of personal information. Other state privacy laws give consumers the right to opt-out of “sales” of personal information and processing of personal information for “targeted advertising” purposes. Please use the opt-out mechanisms below to effectuate these rights, as applicable.'
        },
        {
            type: 'button',
            text: '<b>Opt-Out of Third-Party Tracking Technologies (Slide Right)</b>'
        },
        {
            text: 'Use this toggle to opt-out of disclosures of personal information to advertising partners via tracking technologies on this website, to the extent those disclosures are “sales,” “shares,” or for “targeted advertising” purposes.'
        },
        {
            text: 'Alternatively, you may enable the Global Privacy Control (GPC) signal to effectuate such opt-out. Learn more about GPC at www.globalprivacycontrol.org. '
        },
        {
            text: 'Your opt-out is on the browser level for each device. If you return to this website using a different browser or device, or clear your cookies after using the toggle, you will have to opt out again.'
        },
    ],
    saveBtn: DEFAULT_SAVE_BUTTON_TEXT
};
//# sourceMappingURL=const.js.map